import React from "react";
import TextField from "@material-ui/core/TextField";

export default function FileNameInput(props) {
  return (
    <TextField
      value={props.fileName}
      id="outlined-size-small"
      variant="outlined"
      size="small"
      onChange={props.changeFileName}
    />
  );
}
